import { API } from '@/api';
//import axios from 'axios';

const state = {
  docId: '',
};
// https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage
const getters = {
  // getAdmin: (State) => JSON.parse(window.sessionStorage.getItem('administracion')),
  getDocument: (State) => {
    console.debug('state', state);
    // docId debe ser de tipo string
    // docId = '' corresponde a documento no establecido
    if (typeof state.docId === 'string' && state.docId.length > 0) {
      return state.docId;
    } else if (typeof window.sessionStorage.getItem('docId') === 'string') {
      return window.sessionStorage.getItem('docId');
    } else {
      console.error('Error parsing window.sessionStorage.getItem("docId")');
      return '';
    }
  },
};
const actions = {
  async addFile({commit, State},{clienteId, titulo, contrato, descripcion, tipo, tsa, nom}) {
    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    const formData = new FormData();
    formData.append('title', titulo);
    formData.append('file', contrato);
    formData.append('descripcion', descripcion);
    formData.append('type', tipo);
    formData.append('tsa', tsa);
    formData.append('nom', nom);
    const response = await API.post(`/doc/${clienteId}/upload`, formData, {headers});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
	async addDocumento({commit, State},{clienteId, titulo, contrato, descripcion, tipo, tsa, nom}) {
    const headers = {
      'Content-Type': 'application/json; charset=utf-8',
    };
    const response = await API.post(`/doc/${clienteId}/add`, {title: titulo, doc: contrato, type: tipo, descripcion, tsa: tsa, nom: nom}, {headers});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async getFields({commit, State},{id,clienteId}) {
    const response = await API.get(`/doc/${clienteId}/${id}/fields`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  
  async getDocumento({commit, State},{docId,clienteId}) {
    const response = await API.get(`/doc/${clienteId}/${docId}`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async getContents({commit, State}, {clienteId, docId, downloadType}) {
    const queryString = {downloadType};
    const response = await API.get(`/doc/${clienteId}/${docId}/contents`, {params: queryString});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response;
  },
  async downloadDocumento({commit, State}, {clienteId, docId, download, downloadType}) {
    let queryString = {download: true, downloadType};
    if (download !== undefined) {
      queryString = {download, downloadType};
    }
    const response = await API.get(`/doc/${clienteId}/${docId}/download`, {params: queryString, responseType: 'blob'});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response;
  },
  async getDocumentHtml({commit, State}, {clienteId, docId}) {
    const response = await API.get(`/doc/${clienteId}/${docId}/html`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response;
  },
  async listDocumento({commit, State},{clienteId, options}) {
    let sortBy = '';
    let queryString = {};
    if (options !== undefined) {
      sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
      queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    }
    const response = await API.get(`/doc/${clienteId}/list`, {params: queryString});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async getAlgoritmos({commit, State},{Id}) {
    const response = await API.get(`/algoritmos/get/${Id}`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async listAlgoritmos({commit, State}, {clientId, documentId}) {
    const response = await API.get(`/firma/${clientId}/${documentId}/list/algoritmos`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async limitDocFirmantes({commit, State}, {clientId, documentId}) {
    const response = await API.post(`/doc/${clientId}/terminarDocumento/${documentId}`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  setDocument({ commit, State }, docId) {
    commit('setDocument', docId);
  },
};
const mutations = {
  setDocument: (State, docId) => {
      // docId debe ser string
      State.docId = docId;
      window.sessionStorage.setItem('docId', docId);
  },
};

export default {
  actions,
  mutations,
  getters,
  state,
};
